import { create } from "zustand";

// `loadRecSets` reads localStorage, which is NOT a React dependency — so a view that
// filters/derives from it (the dashboard Action-Flag filter + the row pills) would cache a stale
// snapshot after an Rx save/delete until an unrelated re-render.
interface RecSetsBus {
  version: number;
  bump: () => void;
}

export const useRecSetsBus = create<RecSetsBus>((set) => ({
  version: 0,
  bump: () => set((s) => ({ version: s.version + 1 })),
}));
